import React, { useState, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Header, Icon, Menu } from 'semantic-ui-react';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import {
  setLanguage,
  setLevel,
  setMediaType,
  /* setShowGeneric, */
} from '../libraryActions';
import { languages } from '../applicationForm/SelectData/languages';
import { commonLanguages } from '../applicationForm/SelectData/commonLanguages';
import ReactTooltip from 'react-tooltip';
import { levels } from '../applicationForm/SelectData/levels';
import { media_types } from '../applicationForm/SelectData/media_types';
import ToggleSwitch from '../../../app/common/form/ToggleSwitch';

export default function ApplicationFilters({
  loading,
  setShowAdvanced,
  initLang,
  initLevel,
  initMedia,
  filterType = 'desktop',
  handleSetIsSearch,
}) {
  const dispatch = useDispatch();
  const { language, level, media_type /*, showGeneric*/ } = useSelector(
    (state) => state.library
  );

  const [lastLanguage, setLastLanguage] = useState(null);
  const [lastLevel, setLastLevel] = useState(null);
  const [lastMedia, setLastMedia] = useState(null);
  const [showLanguages, setShowLanguages] = useState(false);
  const [showAllLanguages, setShowAllLanguages] = useState(false);
  const [showLevels, setShowLevels] = useState(false);
  const [showMedia, setShowMedia] = useState(false);

  function handleChangeLanguage(language) {
    if (lastLanguage !== language) {
      dispatch(setLanguage(language));
    } else {
      return false;
    }
    setLastLanguage(language);
    closeAll();
    window.scrollTo(0, 0);
  }

  // function handleShowGeneric() {
  //   dispatch(setShowGeneric(!showGeneric));
  //   closeAll();
  //   window.scrollTo(0, 0);
  // }
  function handleChangeLevel(level) {
    if (lastLevel !== level) {
      dispatch(setLevel(level));
    } else {
    }
    setLastLevel(level);
    closeAll();
    window.scrollTo(0, 0);
  }

  function handleChangeMedia(media_type) {
    if (lastMedia !== media_type) {
      dispatch(setMediaType(media_type));
    }
    setLastMedia(media_type);
    closeAll();
    window.scrollTo(0, 0);
  }

  function closeAll() {
    setShowLanguages(false);
    setShowAllLanguages(false);
    setShowLevels(false);
    setShowMedia(false);
  }

  function handleToggleChange(e) {
    setShowAdvanced(e.target.checked);
  }

  function handleShowLanguages() {
    closeAll();
    setShowLanguages(!showLanguages);
  }

  function handleShowAllLanguages() {
    setShowAllLanguages(!showAllLanguages);
  }

  function handleShowLevels() {
    closeAll();
    setShowLevels(!showLevels);
  }

  function handleShowMedia() {
    closeAll();
    setShowMedia(!showMedia);
  }

  if (loading) return <LoadingComponent content='Loading Filters' />;
  return (
    <>
      <Menu vertical size='large' style={{ width: '100%' }}>
        <Header icon='filter' attached color='teal' content='Filters' />
        <div className='filterBox'>
          <Grid className='filterBox'>
            <div style={{ margin: '20px 20px 20px 20px' }}>
              <span style={{ display: 'inline-block', minWidth: 185 }}>
                Show advanced info
                <Icon
                  name='info circle'
                  style={{ float: 'right' }}
                  data-tip
                  data-for='advanced-tip'
                />
              </span>
              <ToggleSwitch
                name={`advanced_${filterType}`}
                onChange={(e) => handleToggleChange(e)}
              />
            </div>
            {/* <div style={{ margin: '0px 20px 20px 20px' }}>
            <span style={{ display: 'inline-block', minWidth: 185 }}>
              Show generic resources{' '}
              <Icon
                name='info circle'
                style={{ float: 'right' }}
                float='right'
                data-tip
                data-for='generic-tip'
              />
            </span>
            <ToggleSwitch
              name='generic'
              onChange={handleShowGeneric}
              defaultChecked={showGeneric}
            />
          </div> */}
          </Grid>
          {!initLang && (
            <Fragment>
              <Menu.Item
                style={{ paddingLeft: '20px' }}
                onClick={handleShowLanguages}
              >
                <span style={{ display: 'inline-block', minWidth: 100 }}>
                  Language :{' '}
                </span>
                {language ? language : 'All'}
              </Menu.Item>
              {showLanguages && (
                <Fragment>
                  <Menu.Item
                    content='All'
                    active={
                      language === 'All' || language === '' || language === null
                    }
                    onClick={() => handleChangeLanguage('All')}
                    disabled={loading}
                  />
                  {commonLanguages &&
                    showLanguages &&
                    commonLanguages
                      .filter((lang) => lang.value !== 'Any')
                      .map((lang) => (
                        <Menu.Item
                          key={lang.key}
                          content={lang.value}
                          active={language === lang.value}
                          onClick={() => handleChangeLanguage(lang.value)}
                          disabled={loading}
                        />
                      ))}
                  <Menu.Item
                    key='ViewAll'
                    content='View all languages'
                    style={{
                      textAlign: 'center',
                      margin: 10,
                      cursor: 'pointer',
                    }}
                    onClick={handleShowAllLanguages}
                  />
                  {languages &&
                    showAllLanguages &&
                    languages
                      .filter((lang) => lang.value !== 'Any')
                      .map((lang) => (
                        <Menu.Item
                          key={lang.key}
                          content={lang.value}
                          active={language === lang.value}
                          onClick={() => handleChangeLanguage(lang.value)}
                          disabled={loading}
                        />
                      ))}
                </Fragment>
              )}
            </Fragment>
          )}
          {!initLevel && (
            <Fragment>
              <Menu.Item
                style={{ paddingLeft: '20px' }}
                onClick={handleShowLevels}
              >
                <span style={{ display: 'inline-block', minWidth: 100 }}>
                  Level :{' '}
                </span>
                {level ? level : 'All'}
              </Menu.Item>
              {levels &&
                showLevels &&
                levels
                  .filter((lev) => lev.value !== 'All Levels')
                  .map((lev) => (
                    <Menu.Item
                      key={lev.key}
                      active={level === lev.value}
                      onClick={() => handleChangeLevel(lev.value)}
                      disabled={loading}
                    >
                      {lev.value}
                    </Menu.Item>
                  ))}
            </Fragment>
          )}
          {!initMedia && (
            <Fragment>
              <Menu.Item
                style={{ paddingLeft: '20px' }}
                onClick={handleShowMedia}
              >
                <span style={{ display: 'inline-block', minWidth: 100 }}>
                  Media Type :{' '}
                </span>
                {media_type ? media_type : 'All'}
              </Menu.Item>
              {media_types && showMedia && (
                <Menu.Item
                  key='AllMedia'
                  active={level === 'All'}
                  onClick={() => handleChangeMedia('All')}
                  disabled={loading}
                >
                  All
                </Menu.Item>
              )}
              {media_types &&
                showMedia &&
                media_types.map((med) => (
                  <Menu.Item
                    key={med.key}
                    active={level === med.value}
                    onClick={() => handleChangeMedia(med.value)}
                    disabled={loading}
                  >
                    {med.value}
                  </Menu.Item>
                ))}
            </Fragment>
          )}
        </div>
      </Menu>
      <ReactTooltip id='advanced-tip' place='right' type='info'>
        See the list of languages, levels and media types for each resource.
      </ReactTooltip>
      <ReactTooltip id='generic-tip' place='right' type='info'>
        Generic resources are those that are listed as "All languages".
        Sometimes this means they are truely generic language learning sites
        whereas others just cover a huge number of languages.
      </ReactTooltip>
    </>
  );
}
